import React from 'react';
import { StyleSheet } from 'react-native';

import { Ledger, theme } from '@sg/garnish';

import { useLedgerItems } from '../../hooks';
import { type OrderingLedger } from '../../machine';

/**
 * Ledger for this order.
 */
export const BagLedger = (props: BagLedgerProps) => {
  const {
    ledger,
    tip,
    maxTipAmount,
    availableCredit,
    shouldUseCredit,
    amountEligibleForFlex,
    shouldUseFlex,
    discountInfo,
  } = props;

  const ledgerItems = useLedgerItems({
    ledger,
    tip,
    maxTipAmount,
    discountInfo,
    availableCredit,
    shouldUseCredit,
    amountEligibleForFlex,
    shouldUseFlex,
  });

  return (
    <Ledger.Container style={styles.container}>
      {ledgerItems.filter(Boolean).map((item) => (
        <Ledger.Row key={item.label} sizeMatch={['14']} {...item} />
      ))}
    </Ledger.Container>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingBottom: theme.spacing['6'],
    paddingHorizontal: theme.spacing['4'],
    marginHorizontal: -theme.spacing['4'],
    borderTopWidth: theme.spacing['2'],
    borderTopColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  totalMargin: {
    marginTop: theme.spacing['1'],
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type BagLedgerProps = {
  ledger?: OrderingLedger;
  discountInfo?: string; // information shown on a discount tooltip.
  tip: number;
  maxTipAmount: number;
  availableCredit: number;
  shouldUseCredit: boolean;
  amountEligibleForFlex: number | null;
  shouldUseFlex: boolean;
};
